import {motion} from "framer-motion";
import {
    LineBreak,
    LinePoint,
    TitleLine
} from "src/styles/common/sectionStyles";
import {
    mediaLaptop,
    mediaUnderTablet,
    mediaTablet,
    mediaUnderLaptop,
    mediaMaxWidthMobile
} from "src/styles/mediaQuery";
import styled from "styled-components";
import imgContentBg from "src/assets/images/partner_section/img_party.png";
import imgServiceLogoWt from 'src/assets/images/logo-wt.svg';
import speakerImg from 'src/assets/images/partner_section/img_speaker.png';
import graphImg from 'src/assets/images/partner_section/img_graph.png';
import imgDownload from "src/assets/images/partner_section/img_download.png"
import {NavLink} from "react-router-dom";
import {
    Gmarket_DisPlay2_b24,
    Gmarket_DisPlay3_b34,
    Gmarket_Sunbeading_r24
} from "src/styles/font/GmarketSansFonts";
import {Noto_heading1_r20, Noto_SubHeading2_r16, Noto_SubHeading2_r20} from "src/styles/font/NotoSansKrFonts";
interface SectionProps {
    onPartnershipClick?: () => void;
    onProposalClick?: () => void;
}


const containerVariants = {
    initial: {
        opacity: 0,
        y: -200,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            when: "beforeChildren",
            staggerChildren: 0.3,
        },
    },
};

const TextVariants = {
    initial: {
        opacity: 0,
        y: -90,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: "easeOut",
        }
    },
};

const bgVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 0.8,
        transition: {
            duration: 0.7,
            delay: 0.5,
            ease: "easeInOut"
        }
    },
};

const groupVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            when: "beforeChildren",
            staggerChildren: 0.1,
            delayChildren: 0.1,
        },
    },
};

const groupItemVariants = {
    initial: {
        opacity: 0,
        y: 45,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: "easeOut"
        }
    },
};
function PartnerSectionView({ onPartnershipClick, onProposalClick }: SectionProps) {
    return (
        <Section className="section">
            <Inner>
                <ContentsWrap>
                    <Contents
                        variants={containerVariants}
                        initial="initial"
                        whileInView="animate"
                        viewport={{
                            once: true,
                            amount: .35,
                        }}
                    >
                        <ContentBg
                            variants={bgVariants}
                            initial="initial"
                            whileInView="animate"
                            viewport={{
                                once: true,
                            }}
                        ></ContentBg>
                        <TextWrapper
                            variants={TextVariants}
                            initial="initial"
                            whileInView="animate"
                            viewport={{
                                once: true,
                            }}
                        >
                            <TitleLine className="white"><LogoText aria-label="이벤트유"></LogoText>&nbsp;로 시작하세요!<br/>
                                새로운 파트너를<LineBreak className="underMob"/> 기다리고 있어요
                            </TitleLine>
                            <TextLink to="mailto:biz@datau.co.kr">제휴 문의하기&nbsp;<span className="underline">biz@datau.co.kr</span></TextLink>
                        </TextWrapper>
                    </Contents>
                    <Contents>
                        <GroupWrapper
                            variants={groupVariants}
                            initial="initial"
                            whileInView="animate"
                            viewport={{
                                once: true,
                            }}
                        >
                            <Group>
                                <ImageWrapper variants={groupItemVariants}>
                                    <img src={speakerImg} alt="" aria-hidden="true" />
                                </ImageWrapper>
                                <ContentWrapper variants={groupItemVariants}>
                                    <SubTitleText>
                                        공공기관&nbsp;&middot;&nbsp;지자체&nbsp;&middot;&nbsp;기업 홍보
                                        <br />
                                        <LinePoint className="main-color">이벤트U와 함께</LinePoint>하세요
                                    </SubTitleText>
                                    <SubText>
                                        아직도 이벤트 홍보의 어려움을 겪고 계시나요?<br/>
                                        불타는 참여와 공유가 넘쳐나는 이벤트U는 <LineBreak className="pc"/>여러분의 홍보를 도와드려요!
                                    </SubText>
                                </ContentWrapper>
                                <StyledButton id="btn-partnership" variants={groupItemVariants}   onClick={onPartnershipClick}>
                                    서비스 제휴 소개서
                                </StyledButton>
                            </Group>
                            <Group>
                                <ImageWrapper  variants={groupItemVariants}>
                                    <img src={graphImg} alt="" aria-hidden="true" />
                                </ImageWrapper>
                                <ContentWrapper $isSecond={true}  variants={groupItemVariants}>
                                    <SubTitleText>
                                        <LinePoint className="main-color">앱 서비스</LinePoint>를 보유하고 <LineBreak className="pc"/>계신가요?
                                    </SubTitleText>
                                    <SubText>
                                        기업용 이벤트U 솔루션은 자체 프로모션을 통해서<br/> 앱 MAU 활성화를 도와드려요!
                                        고객은 솔루션을 통해 이벤트에 응모하거나 할인 된 가격으로 상품을 구매할 수 있어요
                                    </SubText>
                                </ContentWrapper>
                                <StyledButton id="btn-proposal"  variants={groupItemVariants}  onClick={onProposalClick}>
                                    BIZ 솔루션 제안서
                                </StyledButton>
                            </Group>
                        </GroupWrapper>
                    </Contents>
                </ContentsWrap>
            </Inner>
        </Section>

    );
}

export default PartnerSectionView;


const Section = styled.section`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  min-height: 1080px;
  ${mediaTablet}{
    min-height: unset;
  }
`
const Inner = styled.div`
  ${mediaMaxWidthMobile}{
    padding-top: 50px;
  }
`
const ContentsWrap = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
`;
const Contents = styled(motion.div)`
  &:nth-child(1) {
    position: relative;
    width: 100%;
    height: 560px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    &::after{
      position: absolute;
      content:"";
      width:100%;
      height:100%;
      background-color:var(--point-color-6);
      opacity: .8;
      top:0;
      left:0;
      right:0;
      margin:0 auto;
      z-index: -1;
    }
    ${mediaTablet} {
      height: 402px;
    }
  ${mediaUnderTablet}{
      height: 273px;
    }
  }

  &:nth-child(2) {
    position: relative;
    width: 100%;
    height: auto;
    ${mediaLaptop} {
      height: calc(100% - 452px);
      padding:0 80px;
    }
    ${mediaTablet} {
      padding:0 20px;
      height: calc(100% - 273px);
    }
  }
`;

const ContentBg = styled(motion.div)`
  position: absolute;
  width:100%;
  height: 100%;
  background: url(${imgContentBg})no-repeat center/cover;
  z-index: -1;
 ${mediaTablet} {
    background: url(${imgContentBg})no-repeat left/cover;
  }
  ${mediaUnderTablet} {
    background: url(${imgContentBg})no-repeat  20% /cover;
  }
  
`

const TextWrapper = styled(motion.div)``;
const LogoText = styled.div`
  display: inline-block;
  width:238px;
  height: 44px;
  background: url(${imgServiceLogoWt})no-repeat center/contain;
  vertical-align: middle;
  margin-bottom: 10px;
 ${mediaTablet} {
    width:137px;
    height: 25px;
   margin-bottom: 5px;
  }
  ${mediaUnderTablet} {
    width:104px;
    height: 19px;
  }
`

const TextLink =styled(NavLink)`
  ${Gmarket_Sunbeading_r24};
  display: inline-block;
  color:var(--white);
  margin-top: 19px;
 ${mediaTablet} {
    margin-top: 6px;
    font-size: 17px;
    line-height: 1.6;
  }
  ${mediaUnderTablet} {
    font-size: 13px;
  }
  .underline{
    position:relative;
    letter-spacing: normal;
    &::after{
      content: "";
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      margin: 0 auto;
      width: 100%;
      height: 1px;
      background-color:var(--white);
    }

  }
`


const GroupWrapper = styled(motion.div)`
  width: 100%;
  max-width: 1460px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 287px;
  position: relative;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: -90px;
  ${mediaUnderLaptop} {
    transform: scale(.85);
    top: -120px;
    gap: 110px;
  } 
 ${mediaTablet} {
    justify-content: space-between;
   align-items: flex-start;
    gap: 86px;
    padding: 0 40px 100px;
    top: unset;
  }
  ${mediaUnderTablet} {
    flex-flow: column;
    gap: 50px;
    top: -40px;
    padding: 0 40px 60px;
  }
  ${mediaMaxWidthMobile} {
    padding: 0 0 60px;
  }
`;
const Group = styled(motion.div)`
  width: 100%;
  flex: 1;
 ${mediaTablet} {
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
  }
  ${mediaUnderTablet} {
    align-items: center;
    justify-content: center;
  }
 
`;

const ImageWrapper = styled(motion.div)`
  flex: 1;
  img{
    width:163px;
   ${mediaTablet} {
      width: 130px;
    }
    ${mediaUnderTablet} {
      width: 73px;
    }
  }
`;
const ContentWrapper = styled(motion.div)<{ $isSecond?: boolean }>`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-top: 20px;
  ${mediaTablet} {
    gap: 6px;
    justify-content: center;
    ${props => props.$isSecond && `
    gap: 18px;
  `}
  }
  ${mediaUnderTablet} {
    gap: 6px;
    align-items: center;
  }
}
`

const TitleText = styled(motion.h1)`
  ${Gmarket_DisPlay3_b34};
  word-break: keep-all;
 ${mediaTablet} {
   ${Gmarket_DisPlay2_b24};
    text-align: left;
  }
  ${mediaUnderTablet} {
   font-size: 20px;
    line-height: 1.4;
    text-align: center;
  }
`;

const SubTitleText = styled(motion.h3)`
    ${Gmarket_DisPlay3_b34};
    word-break: keep-all;
    ${mediaTablet} {
        ${Gmarket_DisPlay2_b24};
        text-align: left;
    }
    ${mediaUnderTablet} {
        font-size: 20px;
        line-height: 1.4;
        text-align: center;
    }
`;


const SubText = styled(motion.strong)`
 ${Noto_heading1_r20};
  color:var(--black-70);
  word-break: keep-all;
 ${mediaTablet} {
    ${Noto_SubHeading2_r16};
    text-align: left;
  }
  ${mediaUnderTablet} {
    font-size: 13px;
    line-height: 1.4;
    text-align: center;
  }
`;

const StyledButton = styled(motion.button)`
  ${Noto_SubHeading2_r20};
  max-width: fit-content;
  position: relative;
  display: inline-flex;
  padding: 20px 30px;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  border: 2px solid var(--point-color-1);
  background: var(--white);
  color:var(--point-color-1);
  margin-top: 36px;
  &::after{
    display: inline-block;
    flex-shrink: 0;
    content:"";
    width:24px;
    height:24px;
    background: url(${imgDownload})no-repeat center/cover;
  }
 ${mediaTablet} {
    padding: 16px 20px;
    font-size: 14px;
    line-height: 1.4;
    border-radius: 14px;
    border: 1px solid var(--point-color-1);
    &::after{
      width:18px;
      height:18px;
    }
  }
  ${mediaUnderTablet} {
    margin-top: 20px;
  }
}
`;
